import type { ProgramDayType } from '../types/programs';

const MAP: Record<string, ProgramDayType> = {
  strength: 'strength',
  hiit: 'hiit',
  recovery: 'recovery',
  rest: 'rest',
  off: 'rest',
  cardio: 'cardio',
  run: 'cardio',
  running: 'cardio',
  tempo: 'cardio',
  intervals: 'cardio',
  mobility: 'mobility',
  mob: 'mobility',
  // Common coach labels mapped to non-rest workout types
  upper: 'strength',
  'upper body': 'strength',
  lower: 'strength',
  'lower body': 'strength',
  push: 'strength',
  pull: 'strength',
};

export function normalizeProgramDayType(input: unknown): ProgramDayType {
  if (typeof input === 'string') {
    const key = input.trim().toLowerCase();
    if (MAP[key]) return MAP[key];
    // loose contains checks for phrases
    for (const k of Object.keys(MAP)) {
      if (key.includes(k)) return MAP[k];
    }
  }
  // default: if we truly cannot infer, treat as non-rest so titles still show up and the day isn't hidden as Rest
  return 'strength';
}
